import { PremiumFeaturesApi } from '../../api';
import axios from '../axios';

const premiumFeaturesApi = new PremiumFeaturesApi(undefined, undefined, axios);

export default premiumFeaturesApi;
